import React from 'react';
import styled from 'styled-components';

import Table from 'components/Table';
import { genericDataColumns } from '../helpers';

const ProcessLogs = ({ isLoading, logs }) => {
  const columns = genericDataColumns(logs)
  if (isLoading) return null;

  return (
    <StyledTable
      size="small"
      loading={isLoading}
      dataSource={logs}
      columns={columns}
      rowKey="ts"
    />
  );
};

const StyledTable = styled(Table)`
  & .ant-table {
    overflow: auto;
  }
`;

export default ProcessLogs;
